import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function ArticlesList() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (q) params.append("search", q);
    if (statusFilter) params.append("status", statusFilter);
    params.append("limit", "200");
    api.get(`/articles?${params.toString()}`).then((r) => setItems(r.data.items));
  };
  useEffect(() => { load(); }, [statusFilter]);

  const del = async (id) => {
    if (!confirm("Delete this article?")) return;
    await api.delete(`/articles/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="p-8 md:p-10">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="overline text-[#B4533C]">Articles</div>
          <h1 className="font-serif text-4xl mt-1">All articles</h1>
        </div>
        <Link to="/admin/articles/new" className="bg-[#1B3B36] text-white px-5 py-2.5 text-sm tracking-wide hover:bg-[#112622]" data-testid="create-article-btn">+ New Article</Link>
      </div>
      <div className="flex gap-3 mb-5">
        <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search…" className="border border-[#D6CFC4] px-3 py-2 text-sm flex-1 max-w-sm" data-testid="articles-search" />
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="border border-[#D6CFC4] px-3 py-2 text-sm" data-testid="articles-status-filter">
          <option value="">All statuses</option>
          {["idea","queued","drafting","draft_ready","in_review","scheduled","published","rejected"].map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <button onClick={load} className="border border-[#D6CFC4] px-4 py-2 text-sm" data-testid="articles-refresh">Apply</button>
      </div>
      <div className="border border-[#D6CFC4]">
        <table className="w-full admin-table">
          <thead className="bg-[#EFECE5]"><tr>
            <th className="p-3 text-left">Title</th><th className="p-3 text-left">Category</th><th className="p-3 text-left">Status</th><th className="p-3 text-left">Source</th><th className="p-3 text-left">Updated</th><th className="p-3"></th>
          </tr></thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-[#D6CFC4] hover:bg-[#F9F9F6]" data-testid={`article-row-${a.id}`}>
                <td className="p-3"><Link to={`/admin/articles/${a.id}`} className="hover:text-[#B4533C]">{a.title}</Link></td>
                <td className="p-3 font-mono text-xs">{a.category}</td>
                <td className="p-3 font-mono text-xs">{a.status}</td>
                <td className="p-3 font-mono text-xs">{a.source_type}</td>
                <td className="p-3 font-mono text-xs">{new Date(a.updated_at).toLocaleDateString()}</td>
                <td className="p-3 text-right">
                  <button onClick={() => del(a.id)} className="text-xs text-[#B4533C] hover:underline" data-testid={`article-delete-${a.id}`}>Delete</button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-sm text-[#4A4742]">No articles found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
